import React from "react";

export default function LocationIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 14H4.8C4.6 14 4.4 14.1 4.3 14.2C4.2 14.3 4.1 14.5 4.1 14.7L2.1 20.7C2.0 20.9 2.0 21.1 2.0 21.2C2.1 21.4 2.2 21.5 2.4 21.6C2.5 21.7 2.7 21.8 2.9 21.8H21.1C21.3 21.8 21.5 21.7 21.7 21.6C21.8 21.5 21.9 21.4 22.0 21.2C22.0 21.1 22.0 20.9 21.9 20.7L19.9 14.7C19.8 14.5 19.7 14.3 19.6 14.2C19.4 14.1 19.2 14 19.0 14H15.3M18 8C18 11.6 14.1 15.4 12.6 16.8C12.4 16.9 12.2 17.0 12.0 17.0C11.8 17.0 11.6 16.9 11.4 16.8C9.9 15.4 6.0 11.6 6.0 8C6.0 6.4 6.6 4.9 7.8 3.8C8.9 2.6 10.4 2.0 12.0 2.0C13.6 2.0 15.1 2.6 16.2 3.8C17.4 4.9 18.0 6.4 18.0 8ZM14.0 8C14.0 9.1 13.1 10.0 12.0 10.0C10.9 10.0 10.0 9.1 10.0 8C10.0 6.9 10.9 6.0 12.0 6.0C13.1 6.0 14.0 6.9 14.0 8Z"
        stroke="#71717A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
